import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const CLUId = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      placeholder="Enter CLU ID"
      name="cluID"
      label="CLU ID"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default CLUId;
